/**
 * @generated SignedSource<<2fa42975d5a98c636976db7596ce2cfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CoachProgramCurriculumRouteQuery$variables = {
  endNumber: number;
  maxEnrollments: number;
  programSlug: string;
  startNumber: number;
};
export type CoachProgramCurriculumRouteQuery$data = {
  readonly clients: {
    readonly " $fragmentSpreads": FragmentRefs<"EnrollDialog_clients">;
  } | null | undefined;
  readonly enrollments: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CurriculumEditScreen_enrollments" | "ProgramEnrollmentStartDateViewDialog_enrollments">;
  } | null | undefined;
  readonly enrollmentsAvatars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EnrolledAvatars_connection">;
  } | null | undefined;
  readonly groups: {
    readonly " $fragmentSpreads": FragmentRefs<"EnrollDialog_groups">;
  } | null | undefined;
  readonly program: {
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly " $fragmentSpreads": FragmentRefs<"CurriculumEditScreen_program" | "EnrollDateDialog_program" | "EnrollDialog_program" | "RefreshSlug">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"UnsplashImages_rootRef">;
};
export type CoachProgramCurriculumRouteQuery = {
  response: CoachProgramCurriculumRouteQuery$data;
  variables: CoachProgramCurriculumRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxEnrollments"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "programSlug"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startNumber"
},
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "programSlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "endNumber",
    "variableName": "endNumber"
  },
  {
    "kind": "Variable",
    "name": "startNumber",
    "variableName": "startNumber"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "draft",
    "value": true
  }
],
v14 = [
  (v9/*: any*/)
],
v15 = {
  "kind": "Variable",
  "name": "programSlug",
  "variableName": "programSlug"
},
v16 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "maxEnrollments"
  },
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v19 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 9999
  },
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachProgramCurriculumRouteQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UnsplashImages_rootRef"
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "args": (v8/*: any*/),
            "kind": "FragmentSpread",
            "name": "CurriculumEditScreen_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RefreshSlug"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDialog_program"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDateDialog_program"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDialog_clients"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrollDialog_groups"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "enrollmentsAvatars",
        "args": null,
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "__Program_enrollmentsAvatars_connection",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EnrolledAvatars_connection"
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "enrollments",
        "args": null,
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "__Program_enrollments_connection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProgramEnrollmentStartDateViewDialog_enrollments"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CurriculumEditScreen_enrollments"
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachProgramCurriculumRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Program",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": "weeks",
            "args": (v8/*: any*/),
            "concreteType": "Week",
            "kind": "LinkedField",
            "name": "weekRange",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "week",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "positions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "archived",
                    "value": true
                  }
                ],
                "concreteType": "Component",
                "kind": "LinkedField",
                "name": "components",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previousStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Program",
                    "kind": "LinkedField",
                    "name": "program",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageURL",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v13/*: any*/),
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": "content(draft:true)"
                  },
                  {
                    "alias": null,
                    "args": (v13/*: any*/),
                    "kind": "ScalarField",
                    "name": "teaser",
                    "storageKey": "teaser(draft:true)"
                  },
                  {
                    "alias": null,
                    "args": (v13/*: any*/),
                    "kind": "ScalarField",
                    "name": "image",
                    "storageKey": "image(draft:true)"
                  },
                  {
                    "alias": null,
                    "args": (v13/*: any*/),
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": "title(draft:true)"
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "days",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "repeat",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reminderType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reminderTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "messageTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftExists",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isComponentIcon"
                  }
                ],
                "storageKey": "components(archived:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultView",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "length",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmpty",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slugId",
                "storageKey": null
              }
            ],
            "type": "Slug",
            "abstractKey": "__isSlug"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": (v14/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groups",
        "plural": false,
        "selections": (v14/*: any*/),
        "storageKey": null
      },
      {
        "alias": "enrollmentsAvatars",
        "args": (v16/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "enrollmentsAvatars",
        "args": (v16/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "Program_enrollmentsAvatars",
        "kind": "LinkedHandle",
        "name": "enrollments"
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "concreteType": "EnrollmentConnection",
        "kind": "LinkedField",
        "name": "enrollments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrollmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Enrollment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "raw",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "startDate",
                    "storageKey": "startDate(raw:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v19/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "Program_enrollments",
        "kind": "LinkedHandle",
        "name": "enrollments"
      }
    ]
  },
  "params": {
    "cacheID": "daa8cf974ba96ed3ee2928c691895911",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "maxEnrollments",
          "cursor": null,
          "direction": "forward",
          "path": [
            "enrollmentsAvatars"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "enrollments"
          ]
        }
      ]
    },
    "name": "CoachProgramCurriculumRouteQuery",
    "operationKind": "query",
    "text": "query CoachProgramCurriculumRouteQuery(\n  $programSlug: String!\n  $maxEnrollments: Int!\n  $startNumber: Int!\n  $endNumber: Int!\n) {\n  program(slug: $programSlug) {\n    id\n    name\n    slug\n    ...CurriculumEditScreen_program_4rAFyh\n    ...RefreshSlug\n    ...EnrollDialog_program\n    ...EnrollDateDialog_program\n  }\n  clients {\n    ...EnrollDialog_clients\n  }\n  groups {\n    ...EnrollDialog_groups\n  }\n  enrollmentsAvatars: enrollments(programSlug: $programSlug, first: $maxEnrollments) {\n    totalCount\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...EnrolledAvatars_connection\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  enrollments(programSlug: $programSlug, first: 9999) {\n    edges {\n      cursor\n      node {\n        __typename\n        id\n      }\n    }\n    ...ProgramEnrollmentStartDateViewDialog_enrollments\n    ...CurriculumEditScreen_enrollments\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Avatar_user on User {\n  displayName\n  photoURL\n}\n\nfragment CalendarComponentCard_component on Component {\n  title(draft: true)\n  type\n  status\n  locked\n  ...ComponentIcon_component\n}\n\nfragment ChangeComponentCoverDialog_component_3CJfPz on Component {\n  content(draft: true)\n  teaser(draft: true)\n  image(draft: true)\n  ...ComponentPreview_component_3CJfPz\n  program {\n    imageURL\n    id\n  }\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment ComponentPreview_component_3CJfPz on Component {\n  title(draft: true)\n  teaser(draft: true)\n  image(draft: true)\n  ...ComponentIcon_component\n}\n\nfragment CopyComponentDialog_component on Component {\n  id\n  program {\n    id\n  }\n}\n\nfragment CurriculumEditScreen_enrollments on EnrollmentConnection {\n  edges {\n    node {\n      client {\n        displayName\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment CurriculumEditScreen_program_4rAFyh on Program {\n  weeks: weekRange(startNumber: $startNumber, endNumber: $endNumber) {\n    week\n    id\n    positions\n    components(archived: true) {\n      ...ProgramCalendarComponentButtons_component\n      ...ProgramCalendarComponent_component\n      ...WeekComponentList_components\n      ...DragCellRenderer_component\n      id\n      type\n      status\n      iconName\n      weekId\n      title(draft: true)\n      duration\n      repeat\n      days\n      locked\n      content(draft: true)\n      slug\n      draftExists\n    }\n    ...WeekCard_week\n    ...ProgramCalendarWeek_week\n    ...ProgramSpreadsheetWeek_week\n  }\n  id\n  name\n  slug\n  defaultView\n  length\n  isEmpty\n}\n\nfragment DragCellRenderer_component on Component {\n  ...WeekComponentMenu_component\n  id\n  slug\n  type\n  days\n  status\n  locked\n  draftExists\n}\n\nfragment EnrollDateDialog_program on Program {\n  id\n}\n\nfragment EnrollDialog_clients on ClientConnection {\n  totalCount\n}\n\nfragment EnrollDialog_groups on GroupConnection {\n  totalCount\n}\n\nfragment EnrollDialog_program on Program {\n  id\n  name\n}\n\nfragment EnrolledAvatar_enrollment on Enrollment {\n  client {\n    ...Avatar_user\n    id\n  }\n}\n\nfragment EnrolledAvatars_connection on EnrollmentConnection {\n  totalCount\n  edges {\n    node {\n      id\n      ...EnrolledAvatar_enrollment\n    }\n  }\n}\n\nfragment ProgramCalendarComponentButtons_component on Component {\n  ...WeekComponentMenu_component\n  id\n  slug\n  days\n  status\n  locked\n}\n\nfragment ProgramCalendarComponent_component on Component {\n  type\n  slug\n  ...CalendarComponentCard_component\n}\n\nfragment ProgramCalendarWeek_week on Week {\n  id\n  week\n  description\n}\n\nfragment ProgramEnrollmentStartDateViewDialog_enrollments on EnrollmentConnection {\n  edges {\n    node {\n      id\n      startDate(raw: true)\n      client {\n        displayName\n        ...SelectableClient_client\n        id\n      }\n    }\n  }\n}\n\nfragment ProgramSpreadsheetWeek_week on Week {\n  id\n  week\n  description\n  positions\n}\n\nfragment RefreshSlug on Slug {\n  __isSlug: __typename\n  slug\n  slugId\n}\n\nfragment SelectComponentIcons_component on Component {\n  id\n  iconName\n  type\n}\n\nfragment SelectableClient_client on User {\n  photoURL\n  displayName\n  email\n}\n\nfragment WeekCard_week on Week {\n  ...WeekDrawer_week\n  description\n  positions\n  components(archived: true) {\n    ...WeekComponentList_components\n    id\n  }\n}\n\nfragment WeekComponentListItem_component on Component {\n  type\n  status\n  title(draft: true)\n  image(draft: true)\n  days\n  repeat\n  slug\n  locked\n  ...ComponentIcon_component\n  ...WeekComponentMenu_component\n  ...WeekComponentSchedule_component\n}\n\nfragment WeekComponentList_components on Component {\n  ...WeekComponentListItem_component\n  id\n}\n\nfragment WeekComponentMenu_component on Component {\n  id\n  type\n  status\n  previousStatus\n  weekId\n  locked\n  ...SelectComponentIcons_component\n  ...CopyComponentDialog_component\n  ...ChangeComponentCoverDialog_component_3CJfPz\n}\n\nfragment WeekComponentSchedule_component on Component {\n  duration\n  reminderType\n  reminderTime\n  messageTime\n}\n\nfragment WeekDrawer_week on Week {\n  description\n}\n"
  }
};
})();

(node as any).hash = "871a6294a7066a497e2013f72d46dd35";

export default node;
